var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1745 1.01368C14.8744 0.531381 13.4684 0.267334 12.0006 0.267334C10.5327 0.267287 9.12667 0.531381 7.82669 1.01368L6.7832 12.2673L7.82669 23.5209C9.12662 24.0033 10.5327 24.2673 12.0006 24.2673C13.4684 24.2673 14.8745 24.0033 16.1745 23.5209L17.2179 12.2673L16.1745 1.01368Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 12.2669C23.9999 7.10738 20.7434 2.70877 16.1738 1.01331V23.5206C20.7434 21.825 23.9999 17.4265 23.9999 12.2669Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2668C0 17.4265 3.2565 21.8249 7.82602 23.5205L7.82606 1.01331C3.2565 2.70877 0 7.10724 0 12.2668Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RON.26ed14a398f6b12afb56c7f60e312ad3.svg";